<template>
  <q-card flat>
    <q-card-section>
      Subscription Deadline Notification
      <q-separator class="q-mt-sm" />
    </q-card-section>

    <q-card-section>
      <div class="row q-col-gutter-lg">
        <q-checkbox v-model="model" color="tertiary" label="Automatic deadline notification" />
      </div>
    </q-card-section>
  </q-card>
</template>

<script>
export default {
  props: {
    value: Boolean
  },

  data: () => ({
    model: false
  }),

  watch: {
    value: {
      handler(newVal) {
        this.model = newVal
      },
      immediate: true
    }
  },

  methods: {
    getData() {
      return this.model
    }
  }
}
</script>
